import { render, staticRenderFns } from "./tags-view.vue?vue&type=template&id=0a7ea96e&scoped=true"
import script from "./tags-view.vue?vue&type=script&lang=js"
export * from "./tags-view.vue?vue&type=script&lang=js"
import style0 from "./tags-view.vue?vue&type=style&index=0&id=0a7ea96e&prod&lang=scss"
import style1 from "./tags-view.vue?vue&type=style&index=1&id=0a7ea96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7ea96e",
  null
  
)

export default component.exports